import styled from 'styled-components';

export const MpesaWrapper = styled.div`
  width: 100%;
  max-width: 540px;
  border: 1px solid #e6eaf2;
  border-radius: 20px;
  padding: 16px;
  background: #fff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.06);
  box-sizing: border-box;
  
  @media (max-width: 640px) {
    padding: 12px;
    gap: 12px;
    max-width: 100%;
    margin: 0;
  }
`;

export const MpesaBrand = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  font-size: 20px;
  text-transform: uppercase;
  color: #00a859;

  span {
    color: #c53030;
  }
`;

export const MpesaField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const MpesaLabel = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
`;

export const MpesaInput = styled.input`
  border: 1px solid #d7deea;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.2s ease;
  width: 100%;
  box-sizing: border-box;

  &:focus {
    border-color: #00a859;
    box-shadow: 0 0 0 3px rgba(0, 168, 89, 0.15);
  }
  
  @media (max-width: 640px) {
    font-size: 16px;
    padding: 10px 12px;
  }
`;

export const HelperText = styled.p`
  margin: 0;
  font-size: 13px;
  color: #475569;
`;

export const StatusMessage = styled.div`
  border-radius: 12px;
  padding: 12px 16px;
  background: ${(props) => (props.error ? '#fff5f5' : '#f0fff4')};
  color: ${(props) => (props.error ? '#c53030' : '#065f46')};
  font-size: 14px;
`;

export const MpesaButtonGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

export const MpesaButton = styled.button`
  border: none;
  border-radius: 999px;
  padding: 12px 24px;
  font-weight: 600;
  font-size: 14px;
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  background: ${(props) =>
    props.variant === 'secondary'
      ? '#e2e8f0'
      : props.btnbgcolor || '#00a859'};
  color: ${(props) =>
    props.variant === 'secondary'
      ? '#0f172a'
      : props.btntextcolor || '#ffffff'};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  transition: background 0.2s ease;
  width: 100%;
  box-sizing: border-box;

  &:hover {
    background: ${(props) =>
      props.disabled
        ? undefined
        : props.variant === 'secondary'
        ? '#cbd5f5'
        : props.btnbghvcolor || '#02924c'};
  }
  
  @media (max-width: 640px) {
    padding: 12px 16px;
    font-size: 14px;
  }
`;


